export default "__VITE_ASSET__CPUgh8sM__"